import styled from 'styled-components/macro';
import { spacing09 } from '../../../styling/spacing';
import { ValidityProps } from '../FormField';
import { inputStyles } from './inputStyles';

export const TextArea = styled.textarea<ValidityProps & { expandable?: boolean }>`
  height: ${spacing09};
  min-height: ${spacing09};
  resize: ${props => (!!props.expandable ? 'vertical' : 'none')};
  line-height: 1.6;

  ${props => inputStyles({ $isValid: props.$isValid, $isInvalid: props.$isInvalid })};
`;
